// Author: Ahsan Saleem
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { registerSW } from 'virtual:pwa-register';
import '@fontsource-variable/inter';
import '@fontsource/cormorant-garamond/500.css';
import '@fontsource/cormorant-garamond/600.css';
import './ui/tokens.css';
import './ui/base.css';
import './ui/bloom.css';
import './ui/components.css';
import './ui/shell.css';
import './ui/identity.css';
import './ui/pulse.css';
import './ui/today.css';
import './ui/analytics.css';
import './v2/ui/v2.css';
import './ui/legacy.css';
import { App } from './App.js';
import { ErrorBoundary } from './ui/ErrorBoundary.js';
import { initTheme } from './ui/theme.js';
import { installSyncTriggers } from './outbox.js';

initTheme();

// autoUpdate: the worker self-activates and the page reloads once when a new version
// is deployed — no prompt, and no reload loop (the old prompt called location.reload()
// without activating the waiting worker, so it re-prompted forever).
registerSW({ immediate: true });

installSyncTriggers();

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>,
);
